export const logKeys = {
  all: ['logs'] as const,

  success: () => [...logKeys.all, 'success'] as const,
  successByCompany: (companyId: string) => [...logKeys.success(), 'company', companyId] as const,

  error: () => [...logKeys.all, 'error'] as const,
  errorByCompany: (companyId: string) => [...logKeys.error(), 'company', companyId] as const,
}
